import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/admin`;

export const adminApi = axios.create({ baseURL: BASE, withCredentials: true });

export async function login(email, password) {
  const { data } = await adminApi.post("/login", { email, password });
  return data;
}

export async function logout() {
  await adminApi.post("/logout");
}

export async function me() {
  const { data } = await adminApi.get("/me");
  return data;
}

export async function getStats(params = {}) {
  const { data } = await adminApi.get("/stats", { params });
  return data;
}

export async function getAlertas() {
  const { data } = await adminApi.get("/stats/alertas");
  return data;
}

export async function listarMarcacoes(params = {}) {
  const { data } = await adminApi.get("/marcacoes", { params });
  return data;
}

export async function proximas(limit = 10) {
  const { data } = await adminApi.get("/marcacoes/proximas", { params: { limit } });
  return data;
}

export async function detalheMarcacao(id) {
  const { data } = await adminApi.get(`/marcacoes/${id}`);
  return data;
}

export async function alterarEstado(id, estado, motivo = null) {
  const { data } = await adminApi.patch(`/marcacoes/${id}/estado`, { estado, motivo });
  return data;
}

export async function guardarNotas(id, notas_internas) {
  const { data } = await adminApi.patch(`/marcacoes/${id}/notas`, { notas_internas });
  return data;
}

export async function agendaSemanal(semana_inicio, clinica) {
  const { data } = await adminApi.get("/agenda", { params: { semana_inicio, clinica } });
  return data;
}

export async function listarMensagens(params = {}) {
  const { data } = await adminApi.get("/mensagens", { params });
  return data;
}

export async function atualizarMensagem(id, estado) {
  const { data } = await adminApi.patch(`/mensagens/${id}`, { estado });
  return data;
}

export async function auditLog(limit = 50) {
  const { data } = await adminApi.get("/audit-log", { params: { limit } });
  return data;
}

export const exportCsvUrl = (params = {}) => {
  const search = new URLSearchParams(params).toString();
  return `${BASE}/marcacoes/export.csv${search ? "?" + search : ""}`;
};
